module.exports = __webpack_public_path__ + "static/media/aircombat_ex2.a6810f92.gif";